import React, { memo } from 'react';
import PropTypes from 'prop-types';

import * as icons from '@/assets/icons';
import { CARET_DOWN, CARET_LEFT, CARET_RIGHT, CARET_UP } from '@/constants';

import { IconStyled } from './Icon.styles';

const spriteFilename = `${process.env.APP_ASSETS_PUBLIC_PATH}sprite.${process.env.APP_VERSION}.svg`;

function Icon({ name = '', direction = CARET_DOWN, ...props }) {
  const icon = icons[name];

  if (!icon) {
    return null;
  }

  return (
    <IconStyled viewBox={icon.viewBox} {...props} $direction={direction}>
      <use xlinkHref={`${spriteFilename}#${icon.id}`} />
    </IconStyled>
  );
}

Icon.propTypes = {
  name: PropTypes.string,
  direction: PropTypes.oneOf([CARET_UP, CARET_RIGHT, CARET_DOWN, CARET_LEFT]),
};

export default memo(Icon);
